import { Icon } from '../Icon'
import { CurrencyType } from './CurrencyType'
import React, { FC } from 'react'

type Props = {
  icon: CurrencyType
  type?: 'theme' | 'color' | 'white' | 'dark'
  className?: string
}

export const CurrencyIcon: FC<Props> = ({
  icon,
  type = 'theme',
  className
}) => {
  return (
    <Icon className={className} icon={icon} collection='currency' type={type} />
  )
}
